module.exports = __webpack_public_path__ + "media/beep.ff7edddd.mp3";